import React, { useContext, useState } from "react";
import { useRouter } from "next/router";

import styles from "./keepItemModal.module.css";
import { useUser } from "../../../context/UserContext";
import { useShopContext } from "../../../context/ShopContext";
import { ModalContext } from "../../../context/ModalContext";
import Button from "../../button/Button";
import SelectableImageProductCard from "../../product/SelectableImageProductCard";
import { CartItem } from "../../../commonTypes";

interface Props {
  activeOrderItems: CartItem[];
}

const KeepItemModal: React.FunctionComponent<Props> = ({
  activeOrderItems,
}) => {
  const [itemsToKeep, setItemsToKeep] = useState([]);
  const { handleModal } = useContext(ModalContext);
  const { rotateCart } = useShopContext();
  const router = useRouter();

  const handleKeepItem = (item: CartItem) => {
    if (itemsToKeep.includes(item)) {
      setItemsToKeep(itemsToKeep.filter((x) => x !== item));
    } else {
      setItemsToKeep((current) => [...current, item]);
    }
  };

  const handleConfirm = () => {
    handleModal({ content: false });
    router.push({
      pathname: "/collection",
      query: { set_previous_subscription: true },
    });
    //! below removed as no longer used
    // itemsToKeep.map((item) => {
    //   return (item.keptItem = true);
    // });
    rotateCart(itemsToKeep);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        Do you want to keep anything from your current wardrobe?
      </div>
      <div className={styles.productSection}>
        {activeOrderItems &&
          activeOrderItems.map((item, index) => {
            return (
              <div key={index} className={styles.productItem}>
                <SelectableImageProductCard
                  cartItem={item}
                  onSelect={handleKeepItem}
                />
              </div>
            );
          })}
      </div>
      <div className={styles.button}>
        <Button text="Confirm" onClick={handleConfirm} />
      </div>
    </div>
  );
};

export default KeepItemModal;
